import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import RestAPI from 'components/Common/restApi';

import { BillingPlanFeatureType } from './constants';

type BillingEnabledFeaturesQueryOptions = UseQueryOptions<
  AxiosResponse<{ enabled_features: BillingPlanFeatureType[] }>,
  unknown,
  BillingPlanFeatureType[],
  string[]
>;

const FeaturesKeys = {
  BILLING_ENABLED_FEATURES: 'billing_enabled_features',
};

const fetchData = () =>
  RestAPI.get<{ enabled_features: BillingPlanFeatureType[] }>('/api/v2/pro/product_access/enabled_features');

export const useBillingEnabledFeatures = (options?: BillingEnabledFeaturesQueryOptions) => {
  return useQuery({
    queryKey: [FeaturesKeys.BILLING_ENABLED_FEATURES],
    queryFn: fetchData,
    ...options,
    select: (response) => response.data.enabled_features,
  });
};
